module.exports = __webpack_public_path__ + "img/rentBannerImage.7df82b4a.png";